import Library from '@/library'

const routes = [
  {
    path: '/query',
    name: 'Query',
    component: require('@/views/Search/Query.vue').default,
    props: true
  },

  {
    path: '/search',
    name: 'Search',
    component: require('@/views/Search/Overview.vue').default
  }
]

if (Library.Enums.ObjectType) {
  for (const type of Object.keys(Library.Enums.ObjectType)) {
    if (Library.Entities.isSearchableEntity(type)) {
      if (!routes.find((route) => route.name === `Search ${Library.Filters.toTitleCase(type)}`)) {
        routes.push({
          path: `/${Library.Filters.toUrlCase(type)}`,
          name: `Search ${Library.Filters.toTitleCase(type)}`,
          component: Library.Entities.getSearchComponent(type),
          props: (route) => ({
            type,
            query: route.params.query,
            openEditor: route.params.openEditor || false
          })
        })
      }
    }
  }
}

export default routes
